import React, { useEffect, useState } from "react";
import Input from "../Input/Input";
import RadioButton from "../RadioButton/RadioButton";
import { Collapse } from "react-collapse";

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const Steps = ({ data, setStepsData }) => {
  const [imageIndex, setImageIndex] = useState(0);
  const [isOpenImage, setIsOpenImage] = useState(false);

  const [isOpened0, setIsOpened0] = useState(false);
  const [step0Radio, setStep0Radio] = useState("00");
  const [step0desc, setStep0desc] = useState("");
  const [step0descError, setStep0descError] = useState("");

  const [isOpened1, setIsOpened1] = useState(false);
  const [step1Radio, setStep1Radio] = useState("10");
  const [step1desc, setStep1desc] = useState("");
  const [step1descError, setStep1descError] = useState("");

  const [isOpened2, setIsOpened2] = useState(false);
  const [step2Radio, setStep2Radio] = useState("20");
  const [step2desc, setStep2desc] = useState("");
  const [step2descError, setStep2descError] = useState("");

  const [isOpened3, setIsOpened3] = useState(false);
  const [step3Radio, setStep3Radio] = useState("30");
  const [step3desc, setStep3desc] = useState("");
  const [step3descError, setStep3descError] = useState("");

  const [isOpened4, setIsOpened4] = useState(false);
  const [step4Radio, setStep4Radio] = useState("40");
  const [step4desc, setStep4desc] = useState("");
  const [step4descError, setStep4descError] = useState("");

  useEffect(() => {
    let data = {
      reasons: [],
      product_status:
        step0Radio[1] === "1" ||
        step1Radio[1] === "1" ||
        step2Radio[1] === "1" ||
        step3Radio[1] === "1" ||
        step4Radio[1] === "1"
          ? 5
          : 6,
    };
    if (step0Radio[1] === "1")
      data["reasons"].push({ step: 1, reason: step0desc });
    if (step1Radio[1] === "1")
      data["reasons"].push({ step: 2, reason: step1desc });
    if (step2Radio[1] === "1")
      data["reasons"].push({ step: 3, reason: step2desc });
    if (step3Radio[1] === "1")
      data["reasons"].push({ step: 4, reason: step3desc });
    if (step4Radio[1] === "1")
      data["reasons"].push({ step: 5, reason: step4desc });
    setStepsData(data);
  }, [
    setStepsData,
    step0Radio,
    step0desc,
    step1Radio,
    step1desc,
    step2Radio,
    step2desc,
    step3Radio,
    step3desc,
    step4Radio,
    step4desc,
  ]);

  useEffect(() => {
    if (!isOpened0 && step0Radio[1] === "1" && step0desc === "") {
      setStep0descError("توضیحات را وارد کنید");
      setIsOpened0(true);
    }
  }, [isOpened0, step0Radio, step0desc]);

  useEffect(() => {
    if (!isOpened1 && step1Radio[1] === "1" && step1desc === "") {
      setStep1descError("توضیحات را وارد کنید");
      setIsOpened1(true);
    }
  }, [isOpened1, step1Radio, step1desc]);

  useEffect(() => {
    if (!isOpened2 && step2Radio[1] === "1" && step2desc === "") {
      setStep2descError("توضیحات را وارد کنید");
      setIsOpened2(true);
    }
  }, [isOpened2, step2Radio, step2desc]);

  useEffect(() => {
    if (!isOpened3 && step3Radio[1] === "1" && step3desc === "") {
      setStep3descError("توضیحات را وارد کنید");
      setIsOpened3(true);
    }
  }, [isOpened3, step3Radio, step3desc]);

  useEffect(() => {
    if (!isOpened4 && step4Radio[1] === "1" && step4desc === "") {
      setStep4descError("توضیحات را وارد کنید");
      setIsOpened4(true);
    }
  }, [isOpened4, step4Radio, step4desc]);

  return (
    <div className='flex flex-col gap-3'>
      {/* step0*/}
      <div>
        <div
          className={`bgtrans mx-1 rounded-t-xl ${
            isOpened0 ? "bg-gray-200 " : ""
          }`}
        >
          <div
            className='flex justify-between items-center rounded-xl shadow p-3 bg-white'
            onClick={() => {
              debugger;
              // if (step0Radio[1] === "1" && step0desc === "")
              //   setStep0descError("توضیحات را وارد کنید");
              // else {
              setIsOpened0(!isOpened0);
              if (!isOpened0) {
                setIsOpened1(false);
                setIsOpened2(false);
                setIsOpened3(false);
                setIsOpened4(false);
              }
              // }
            }}
          >
            <div className='flex items-center justify-start gap-2 '>
              <img
                className=''
                src='/statics/images/state0-active.svg'
                width='32px'
                height='32px'
                alt='state0'
              />
              <span>مرحله اول</span>
            </div>

            <div>
              <img
                className=''
                src={
                  isOpened0
                    ? "/statics/images/minus.svg"
                    : "/statics/images/plus.svg"
                }
                width='14px'
                alt='arrow'
              />
            </div>
          </div>
        </div>

        <Collapse isOpened={isOpened0}>
          <div className='p-5 bg-gray-200 mx-1 rounded-b-xl'>
            <div className='grid grid-cols-1 md:grid-cols-3 gap-y-5 md:gap-20'>
              <div className='col-span-2 md:mr-8 flex flex-col gap-6'>
                <div className='flex flex-col gap-2'>
                  <div className='font-bold'>دسته بندی</div>
                  <div className='text-gray-500'>
                    {data?.category_detail?.name}
                  </div>
                </div>

                <div className='flex flex-col gap-2'>
                  <div className='font-bold'>توضیحات</div>
                  <div className='text-gray-500'>{data?.description}</div>
                </div>

                <div className='flex flex-col gap-2'>
                  <div className='font-bold'>وضعیت</div>
                  <div className='text-gray-500'>
                    {data?.product_type === 0 ? "مستعمل" : "نو"}
                  </div>
                </div>
              </div>

              <div
                className='col-span-1 rounded-xl shadow bg-white p-3 md:py-5 md:px-8'
                style={{ height: "fit-content" }}
              >
                <RadioButton
                  data={[
                    { value: "00", label: "تایید" },
                    { value: "01", label: "عدم تایید" },
                  ]}
                  change={(value) => {
                    setStep0Radio(value);
                    setStep0desc("");
                    setStep0descError("");
                  }}
                  fontSize='12px'
                  checkedValue={step0Radio}
                />
                {step0Radio[1] === "1" && (
                  // <div
                  //   className={`ConfirmContainer ${
                  //     fadeIn ? "showConfirm" : "hideConfirm"
                  //   }`}
                  // >

                  <div className='mt-5'>
                    <div className='text-xs text-center'>
                      درصورت غیر فعال کردن این کالا دلیل آن را ذکر کنید
                    </div>
                    <Input
                      placeholder='توضیحات'
                      maxWidth='100%'
                      value={step0desc}
                      error={step0descError}
                      type='text'
                      textarea
                      margin='0'
                      onChange={(event) => {
                        let { value } = event.target;
                        setStep0desc(value);
                        setStep0descError("");
                      }}
                    />
                  </div>
                  // </div>
                )}
              </div>
            </div>
          </div>
        </Collapse>
      </div>

      {/* step1*/}
      <div>
        <div
          className={`bgtrans mx-1 rounded-t-xl ${
            isOpened1 ? "bg-gray-200 " : ""
          }`}
        >
          <div
            className='flex justify-between items-center rounded-xl shadow p-3 bg-white'
            onClick={() => {
              setIsOpened1(!isOpened1);
              if (!isOpened1) {
                setIsOpened0(false);
                setIsOpened2(false);
                setIsOpened3(false);
                setIsOpened4(false);
              }
            }}
          >
            <div className='flex items-center justify-start gap-2 '>
              <img
                className=''
                src='/statics/images/state1-active.svg'
                width='32px'
                height='32px'
                alt='state0'
              />
              <span>مرحله دوم</span>
            </div>

            <div>
              <img
                className=''
                src={
                  isOpened1
                    ? "/statics/images/minus.svg"
                    : "/statics/images/plus.svg"
                }
                width='14px'
                alt='arrow'
              />
            </div>
          </div>
        </div>

        <Collapse isOpened={isOpened1}>
          <div className='p-5 bg-gray-200 mx-1 rounded-b-xl'>
            <div className='grid grid-cols-1 md:grid-cols-3 gap-y-5 md:gap-20'>
              <div className='col-span-2 md:mr-8'>
                {data?.options?.length > 0 ? (
                  <div className='grid grid-cols-1 md:grid-cols-2 gap-y-6'>
                    {data?.options?.map((row) => (
                      <>
                        <div
                          className='flex flex-col gap-2 border-b-2 border-gray-300'
                          key={row.id}
                        >
                          <div className='font-bold'>
                            {Object.keys(row.value)}
                          </div>
                          <div className='text-gray-500'>
                            {Object.values(row.value)}
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                ) : (
                  <div className='grid grid-cols-1 gap-y-6'>
                    {data?.manual_options?.map((row) => (
                      <>
                        <div
                          className='flex flex-col gap-2 border-b-2 border-gray-300'
                          key={row.id}
                        >
                          <div className='text-gray-500'>{row.amount}</div>
                        </div>
                      </>
                    ))}
                  </div>
                )}
              </div>

              <div
                className='col-span-1 rounded-xl shadow bg-white p-3 md:py-5 md:px-8'
                style={{ height: "fit-content" }}
              >
                <RadioButton
                  data={[
                    { value: "10", label: "تایید" },
                    { value: "11", label: "عدم تایید" },
                  ]}
                  change={(value) => {
                    setStep1Radio(value);
                    setStep1desc("");
                    setStep1descError("");
                  }}
                  fontSize='12px'
                  checkedValue={step1Radio}
                />
                {step1Radio[1] === "1" && (
                  <div className='mt-5'>
                    <div className='text-xs text-center'>
                      درصورت غیر فعال کردن این کالا دلیل آن را ذکر کنید
                    </div>
                    <Input
                      placeholder='توضیحات'
                      maxWidth='100%'
                      value={step1desc}
                      error={step1descError}
                      type='text'
                      textarea
                      margin='0'
                      onChange={(event) => {
                        let { value } = event.target;
                        setStep1desc(value);
                        setStep1descError("");
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Collapse>
      </div>

      {/* step2*/}
      <div>
        <div
          className={`bgtrans mx-1 rounded-t-xl ${
            isOpened2 ? "bg-gray-200 " : ""
          }`}
        >
          <div
            className='flex justify-between items-center rounded-xl shadow p-3 bg-white'
            onClick={() => {
              setIsOpened2(!isOpened2);
              if (!isOpened2) {
                setIsOpened0(false);
                setIsOpened1(false);
                setIsOpened3(false);
                setIsOpened4(false);
              }
            }}
          >
            <div className='flex items-center justify-start gap-2 '>
              <img
                className=''
                src='/statics/images/state2-active.svg'
                width='32px'
                height='32px'
                alt='state0'
              />
              <span>مرحله سوم</span>
            </div>

            <div>
              <img
                className=''
                src={
                  isOpened2
                    ? "/statics/images/minus.svg"
                    : "/statics/images/plus.svg"
                }
                width='14px'
                alt='arrow'
              />
            </div>
          </div>
        </div>

        <Collapse isOpened={isOpened2}>
          <div className='p-5 bg-gray-200 mx-1 rounded-b-xl'>
            <div className='grid grid-cols-1 md:grid-cols-3 gap-y-5 md:gap-20'>
              <div className='col-span-2 md:mr-8'>
                <div>تصویر کالا</div>

                <div className='grid grid-cols-1 gap-y-6'>
                  {data?.image?.map((row, index) => (
                    <div
                      key={row.id}
                      className='rounded-2xl bg-blue3 px-5 py-2 my-2'
                    >
                      <div className='flex justify-between items-center gap-5'>
                        <div className='flex gap-5'>
                          <img
                            className='rounded-lg  w-16 h-16'
                            src={row.image}
                            width='100px'
                            height='100px'
                            alt='arrow'
                            onClick={() => {
                              setIsOpenImage(true);
                              setImageIndex(index);
                            }}
                          />
                          <div className='flex flex-col justify-between items-start'>
                            <div className='font-semibold'>
                              {
                                row.image.split("/")[
                                  row.image.split("/").length - 1
                                ]
                              }
                            </div>
                            {/* <div>{formatBytes(row.size)} </div> */}
                          </div>
                        </div>
                        <div>
                          <img
                            className='cursor'
                            src='/statics/images/tick.svg'
                            width='20px'
                            // height='10px'
                            alt='arrow'
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {isOpenImage && (
                  // .find((item) => item.id === imageIndex)
                  <Lightbox
                    mainSrc={data?.image[imageIndex]?.image}
                    nextSrc={
                      data?.image[(imageIndex + 1) % data?.image.length]?.image
                    }
                    prevSrc={
                      data?.image[
                        (imageIndex + data?.image.length - 1) %
                          data?.image.length
                      ]?.image
                    }
                    onCloseRequest={() => setIsOpenImage(false)}
                    onMoveNextRequest={() =>
                      setImageIndex(
                        (imageIndex + data?.image.length - 1) %
                          data?.image.length
                      )
                    }
                    onMovePrevRequest={() =>
                      setImageIndex((imageIndex + 1) % data?.image.length)
                    }
                  />
                )}
              </div>

              <div
                className='col-span-1 rounded-xl shadow bg-white p-3 md:py-5 md:px-8'
                style={{ height: "fit-content" }}
              >
                <RadioButton
                  data={[
                    { value: "20", label: "تایید" },
                    { value: "21", label: "عدم تایید" },
                  ]}
                  change={(value) => {
                    setStep2Radio(value);
                    setStep2desc("");
                    setStep2descError("");
                  }}
                  fontSize='12px'
                  checkedValue={step2Radio}
                />
                {step2Radio[1] === "1" && (
                  <div className='mt-5'>
                    <div className='text-xs text-center'>
                      درصورت غیر فعال کردن این کالا دلیل آن را ذکر کنید
                    </div>
                    <Input
                      placeholder='توضیحات'
                      maxWidth='100%'
                      value={step2desc}
                      error={step2descError}
                      type='text'
                      textarea
                      margin='0'
                      onChange={(event) => {
                        let { value } = event.target;
                        setStep2desc(value);
                        setStep2descError("");
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Collapse>
      </div>

      {/* step3*/}
      <div>
        <div
          className={`bgtrans mx-1 rounded-t-xl ${
            isOpened3 ? "bg-gray-200 " : ""
          }`}
        >
          <div
            className='flex justify-between items-center rounded-xl shadow p-3 bg-white'
            onClick={() => {
              setIsOpened3(!isOpened3);
              if (!isOpened3) {
                setIsOpened0(false);
                setIsOpened1(false);
                setIsOpened2(false);
                setIsOpened4(false);
              }
            }}
          >
            <div className='flex items-center justify-start gap-2 '>
              <img
                className=''
                src='/statics/images/state3-active.svg'
                width='32px'
                height='32px'
                alt='state0'
              />
              <span>مرحله چهارم</span>
            </div>

            <div>
              <img
                className=''
                src={
                  isOpened3
                    ? "/statics/images/minus.svg"
                    : "/statics/images/plus.svg"
                }
                width='14px'
                alt='arrow'
              />
            </div>
          </div>
        </div>

        <Collapse isOpened={isOpened3}>
          <div className='p-5 bg-gray-200 mx-1 rounded-b-xl'>
            <div className='grid grid-cols-1 md:grid-cols-3 gap-y-5 md:gap-20'>
              <div className='col-span-2 md:mr-8'>
                <div className='grid grid-cols-1 gap-y-6'>
                  <div className='grid grid-cols-1 md:grid-cols-2 '>
                    <div className='flex flex-col gap-2'>
                      <div className='font-bold'>استان</div>
                      <div className='text-gray-500'>
                        {data?.address?.province_detail?.name}
                      </div>
                    </div>

                    <div className='flex flex-col gap-2'>
                      <div className='font-bold'>شهر</div>
                      <div className='text-gray-500'>
                        {data?.address?.city_detail?.name}
                      </div>
                    </div>
                  </div>

                  <div className='flex flex-col gap-2'>
                    <div className='font-bold'>
                      آدرس مورد نظر برای مکان معاوضه
                    </div>
                    <div className='text-gray-500'>
                      {data?.address?.address}
                    </div>
                  </div>
                </div>
              </div>

              <div
                className='col-span-1 rounded-xl shadow bg-white p-3 md:py-5 md:px-8'
                style={{ height: "fit-content" }}
              >
                <RadioButton
                  data={[
                    { value: "30", label: "تایید" },
                    { value: "31", label: "عدم تایید" },
                  ]}
                  change={(value) => {
                    setStep3Radio(value);
                    setStep3desc("");
                    setStep3descError("");
                  }}
                  fontSize='12px'
                  checkedValue={step3Radio}
                />
                {step3Radio[1] === "1" && (
                  <div className='mt-5'>
                    <div className='text-xs text-center'>
                      درصورت غیر فعال کردن این کالا دلیل آن را ذکر کنید
                    </div>
                    <Input
                      placeholder='توضیحات'
                      maxWidth='100%'
                      value={step3desc}
                      error={step3descError}
                      type='text'
                      textarea
                      margin='0'
                      onChange={(event) => {
                        let { value } = event.target;
                        setStep3desc(value);
                        setStep3descError("");
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Collapse>
      </div>

      {/* step4*/}
      <div>
        <div
          className={`bgtrans mx-1 rounded-t-xl ${
            isOpened4 ? "bg-gray-200 " : ""
          }`}
        >
          <div
            className='flex justify-between items-center rounded-xl shadow p-3 bg-white'
            onClick={() => {
              setIsOpened4(!isOpened4);
              if (!isOpened4) {
                setIsOpened0(false);
                setIsOpened1(false);
                setIsOpened2(false);
                setIsOpened3(false);
              }
            }}
          >
            <div className='flex items-center justify-start gap-2 '>
              <img
                className=''
                src='/statics/images/state4-active.svg'
                width='32px'
                height='32px'
                alt='state0'
              />
              <span>مرحله پنجم</span>
            </div>

            <div>
              <img
                className=''
                src={
                  isOpened4
                    ? "/statics/images/minus.svg"
                    : "/statics/images/plus.svg"
                }
                width='14px'
                alt='arrow'
              />
            </div>
          </div>
        </div>

        <Collapse isOpened={isOpened4}>
          <div className='p-5 bg-gray-200 mx-1 rounded-b-xl'>
            <div className='grid grid-cols-1 md:grid-cols-3 gap-y-5 md:gap-20'>
              <div className='col-span-2 md:mr-8'>
                <div className='mt-5 md:mt-0 mb-10 '>
                  علاقمند های آگهی دهنده
                </div>
                <div className='grid grid-cols-1 gap-4'>
                  {data?.desire?.map((row) => (
                    <div key={row.id}>
                      <div className='text-gray-500'>{row?.parent?.name}</div>

                      <div
                        key={row.id}
                        className='border rounded-lg shadow py-3 my-3 pl-8 flex justify-start items-center h-16 relative bg-white'
                        style={{ width: "fit-content" }}
                      >
                        {row?.image?.length > 0 ? (
                          <img
                            className='w-20 h-20 absolute -right-1 inset-y-0 my-auto rounded-lg shadow bg-gray-100'
                            src={row?.image[0]?.image}
                            width='50px'
                            height='50px'
                            alt='arrow'
                          />
                        ) : (
                          <img
                            className='w-20 h-20 absolute -right-1 inset-y-0 my-auto rounded-lg shadow bg-gray-100 p-5'
                            src='/statics/images/no_picture.svg'
                            width='50px'
                            height='50px'
                            alt='arrow'
                          />
                        )}
                        <div className='flex flex-col mr-20 pr-1 overflow-hidden '>
                          <div className='flex flex-wrap'>{row.title}</div>
                        </div>
                      </div>
                      <div className=''>{row.description}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div
                className='col-span-1 rounded-xl shadow bg-white p-3 md:py-5 md:px-8'
                style={{ height: "fit-content" }}
              >
                <RadioButton
                  data={[
                    { value: "40", label: "تایید" },
                    { value: "41", label: "عدم تایید" },
                  ]}
                  change={(value) => {
                    setStep4Radio(value);
                    setStep4desc("");
                    setStep4descError("");
                  }}
                  fontSize='12px'
                  checkedValue={step4Radio}
                />
                {step4Radio[1] === "1" && (
                  <div className='mt-5'>
                    <div className='text-xs text-center'>
                      درصورت غیر فعال کردن این کالا دلیل آن را ذکر کنید
                    </div>
                    <Input
                      placeholder='توضیحات'
                      maxWidth='100%'
                      value={step4desc}
                      error={step4descError}
                      type='text'
                      textarea
                      margin='0'
                      onChange={(event) => {
                        let { value } = event.target;
                        setStep4desc(value);
                        setStep4descError("");
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default Steps;
